import { u as i } from "../styled-components.browser.esm-3eb04950.js";
const p = i.div`
    display: flex;
    gap: 15px;
    flex-direction: ${({ $isMedia: o }) => o ? "row" : "column"};
`;
export {
  p as Action
};
//# sourceMappingURL=Action.js.map
